import { NgModule, ModuleWithProviders } from '@angular/core';
import { CartService } from '../finance/shared/services/cart.service';

@NgModule()
export class CartCoreModule {

    static forRoot(): ModuleWithProviders<CartCoreModule> {
        return {
            ngModule: CartCoreModule,
            providers: [
                CartService
            ]
        };
    }
}
